import { NavLink } from 'react-router-dom';

const items = [
  { to: '/vendors', label: 'Directory', end: true },
  { to: '/vendors/performance', label: 'Performance', end: false },
  { to: '/vendors/work', label: 'My work', end: false },
];

/** Section switcher shared by the Vendors pages. */
export function VendorSectionNav() {
  return (
    <nav aria-label="Vendors sections" className="flex gap-1 overflow-x-auto border-b border-gray-200">
      {items.map((item) => (
        <NavLink
          key={item.label}
          to={item.to}
          end={item.end}
          className={({ isActive }) => `relative inline-flex min-h-10 shrink-0 items-center px-3 text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-600 ${isActive ? 'text-blue-800 after:absolute after:inset-x-3 after:bottom-0 after:h-0.5 after:bg-blue-600' : 'text-gray-600 hover:text-gray-900'}`}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
